import Image from 'next/legacy/image';
import Link from 'next/link';

import styles from './confirmBlock.module.css';

import confirmImage from '../../public/assets/images/confirm_pic.png';

const ConfirmBlock = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.image_container}>
        <Image
          layout={`fill`}
          objectFit={`cover`}
          quality={100}
          src={confirmImage} />
      </div>
      <p>Submitted Successfully !</p>
      <Link href={`/`} className={`custom__purple-button`}>
        Return To Homepage
      </Link>
    </div>
  );
};

export default ConfirmBlock;
